import { render, staticRenderFns } from "./TempOrder.vue?vue&type=template&id=4ccfab05&scoped=true&"
import script from "./TempOrder.vue?vue&type=script&lang=js&"
export * from "./TempOrder.vue?vue&type=script&lang=js&"
import style0 from "./TempOrder.vue?vue&type=style&index=0&id=4ccfab05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccfab05",
  null
  
)

export default component.exports